import CalendarInput from '@libs/forms/CalendarInput'
import InputField from '@libs/forms/InputField'
import { MAX_LENGTH } from '@libs/forms/utils/constants'
import { sanitizeEmail, sanitizeName } from '@libs/forms/utils/sanitations'
import RaQFormContentWrapper from '@modules/requestAQuote/components/RaQFormContentWrapper'
import TripPreferences from '@modules/requestAQuote/components/TripPreferences'
import InputPhone from '@libs/forms/InputPhone'

const LayoutBStepOne = ({
  isOnStickyRaQ,
  calendarInputProps,
  tripPreferencesProps,
}: any): JSX.Element => {
  return (
    <RaQFormContentWrapper>
      <div className='flex flex-col gap-[24px] mb-6'>
        <InputField
          name='fullName'
          label='Full Name'
          type='name'
          hasAsterisk={true}
          maxLength={MAX_LENGTH.name}
          sanitize={sanitizeName}
          isOnStickyRaQ={isOnStickyRaQ}
        />
        <InputField
          name='email'
          label='Email'
          type='email'
          hasAsterisk={true}
          maxLength={MAX_LENGTH.email}
          sanitize={sanitizeEmail}
          isOnStickyRaQ={isOnStickyRaQ}
        />
        <InputPhone name='phoneNumber' />
        <CalendarInput
          {...calendarInputProps}
          label='Travel Dates'
          isOnStickyRaQ={isOnStickyRaQ}
        />
      </div>
      <TripPreferences {...tripPreferencesProps} />
    </RaQFormContentWrapper>
  )
}

export default LayoutBStepOne
